import {createSelector} from 'reselect';

export const getUsedDeliveryAddressOnPaymentResolutionPage = state => state.start.deliveryAddress;

export const getSelectedDeliveryCountryOnPaymentResolutionPage = createSelector(
  [getUsedDeliveryAddressOnPaymentResolutionPage],
  selectedAddress => selectedAddress?.countryCode,
);

export const getUsedDeliveryAddressOnPaymentResolutionPageInAPIFormat = createSelector(
  [getUsedDeliveryAddressOnPaymentResolutionPage],
  selectedAddress => (selectedAddress && {
    addressId: selectedAddress.addressId,
    addressee: selectedAddress.addressee,
    companyName: selectedAddress.organisationName,
    houseNameNumber: selectedAddress.buildingNameNumber,
    streetName: selectedAddress.line1,
    addressLine2: selectedAddress.line2,
    town: selectedAddress.line3,
    county: selectedAddress.line4,
    postCode: selectedAddress.postcode,
    countryCode: selectedAddress.countryCode,
    residentId: selectedAddress.residentId,
    contactNumber: selectedAddress.contactNumber,
  }),
);
